import { Stack, StackProps } from "@/storybook-components";

interface QuestionContentProps extends StackProps {}

const QuestionContent = (props: QuestionContentProps) => {
  return <Stack {...props}>{props.children}</Stack>;
};

export { QuestionContent };
export type { QuestionContentProps };
